import EditReminderModal from './EditReminderModal';

export default EditReminderModal;
